import { Logger } from '@booket-uk/logging';

export const log = new Logger(console);
